import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IReprocessEntubaRequest } from "../interface/entuba/IReprocessEntubaRequest";

enum PricingBatchServiceEnum {
  getAll = "/",
  getDetail = "",
  start = "/start",
  reprocess = "/reprocess"
}

export default class PricingBatchService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/batch/pricing");
  }

  public startPricingBatch = async data => await this.PUT(PricingBatchServiceEnum.start, data);
  public reprocessPricingBatch = async (data: IReprocessEntubaRequest) => await this.PUT(PricingBatchServiceEnum.reprocess, data);

  public getDetail = async idBatch => {
    const data = await this.GET(`${PricingBatchServiceEnum.getDetail}/${idBatch}`);
    return data;
  };
}



// WEBPACK FOOTER //
// ./src/services/api/PricingBatch.service.ts